import React from 'react';
import { TransactionExportsTable } from './TransactionExportsTable';

export const TransactionExportsList: React.FC = () => {
  return <TransactionExportsTable />;
};
